<nav class="navbar navbar-expand-lg navbar-light ">
    <a class="navbar-brand" href="#">
        <img src="assets/images/brand.png" class="imgg"></a>
</nav>
<div *ngIf="showError" class="mt-5 text-center" role="alert">
    <ng-container *ngIf="aclDenied; else genericError">
        <strong>Login Access Restricted</strong>
        <p>Your current network is not permitted by your organization's login access policy.
            Please contact your administrator if you need access from this location.</p>
        <p *ngIf="sourceIp">Detected source IP: {{sourceIp}}</p>
    </ng-container>
    <ng-template #genericError>
        There was a problem accessing the device portal, please try again.
    </ng-template>
</div>
